<nav class="navigation">
  <ng-container *ngFor="let item of items">
    <ng-container *ngxPermissionsOnly="item.permissions || []">
      <a
        class="navigation-item"
        [routerLink]="item.link"
        [queryParams]="item.queryParams"
        routerLinkActive="navigation-item_active"
        [tuiHintDescribe]="'navigation'"
        [tuiHintDirection]="'right'"
        [tuiHint]="isOpen ? '' : (item.title | translate)"
        [tuiHintShowDelay]="300"
        [tuiHintHideDelay]="0"
        (click)="item.action && item.action()"
      >
        <div *ngIf="item.icon" class="navigation-item__icon">
          <app-icon class="icon" [size]="'24px'" [src]="item.icon"></app-icon>

          <tui-badge *ngIf="item.badgeCount | async as badgeCount" class="badge" [size]="'s'">
            {{ badgeCount }}
          </tui-badge>
        </div>

        <div *ngIf="isOpen">
          <div class="navigation-item__title">
            {{ item.title | translate }}
          </div>
          <div *ngIf="descriptionVisible" class="navigation-item__description">
            {{ item.description || '' | translate }}
          </div>
        </div>

        <tui-badge
          *ngIf="!!item.badge"
          class="navigation-item__badge"
          [ngClass]="isOpen ? '' : 'navigation-item__badge_bottom'"
          [size]="'s'"
        >
          {{ item.badge }}
        </tui-badge>
      </a>
    </ng-container>
  </ng-container>
</nav>
